import { ENV } from '@/lib/config';

/** An agent another service hosts by mounting Relay's routes. */
export interface RelayAgentConnection {
  /** The hosting service, such as `ENV.ASSETS_API_BASE_URL`. */
  baseUrl: string;
  agentId: string;
  /** Shown on its approval cards and its card in the chat, where the reasoner would name it. */
  agentName: string;
  /** How its approval cards name a tool, by the name the agent calls it by. */
  toolLabel?: (toolName: string) => string;
  /** Reads PDF documents given in the chat itself; other files its tools open by id. */
  documents?: boolean;
}

/** An agent assets-api hosts. A tool without a label shows under its own name. */
export function assetsApiAgent(
  agentId: string,
  agentName: string,
  toolLabels: Readonly<Record<string, string>> = {},
): RelayAgentConnection {
  return {
    baseUrl: ENV.ASSETS_API_BASE_URL,
    agentId,
    agentName,
    toolLabel: (toolName) => toolLabels[toolName] ?? toolName,
  };
}
